/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';

const JournalEntryBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useJournalEntryUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Journal Entries" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default JournalEntryBreadcrumbs;
